module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "header": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('h2', {
    staticClass: "mb-4 text-center bold"
  }, [_vm._v("Learn more about Group Prices")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableData.titles), function(data, i) {
    return _c('th', {
      key: ("title-" + i),
      attrs: {
        "width": data.width
      }
    }, [_vm._v("\n                            " + _vm._s(data.title) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.rows), function(row, j) {
    return _c('tr', {
      key: ("row-" + j)
    }, [_c('td', [_vm._v(_vm._s(row.priceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.channelCompatibility))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-00083984", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00083984"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/PerGroupLearnMore.vue
// module id = 1571
// module chunks = 0